module.exports = __webpack_public_path__ + "assets/img/advantages.065fd974.png";